import type { FetchStatusType, StatusType } from './status_type';

export function statusShortcuts(
  status: StatusType,
  fetchStatus: FetchStatusType,
) {
  return {
    isLoading: status === 'pending' && fetchStatus === 'fetching',
  };
}
